import { routes as CheckoutRoutes } from "./apps/checkout/routes";
import { routes as ProfileRoutes } from "./apps/profile/routes";
import { routes as WebRoutes } from "./apps/web/routes";

export const routes = {
  ...ProfileRoutes,
  ...CheckoutRoutes,
  ...WebRoutes
};
